import { gql } from 'graphql.macro'

export default gql`
  fragment EventBaseFragment on Event {
    id
    data
    timestamp
  }
`
